import { HttpHandler } from 'msw'

import { clients } from './clients'
import { managers } from './managers'
import { sites } from './sites'

export const park: HttpHandler[] = [...clients, ...managers, ...sites]
